import { useParams } from "react-router-dom";

import Heading from "../../shared/ui/Typography/Heading";
import Text from "../../shared/ui/Typography/Text";
import { ClientActivityScreenContent } from "../../features/clientActivity";

// ClientActivityScreen — route landing for /clients/:clientId/activity.
// Mounts under MainLayout. Thin composition wrapper around the feature
// widget. No selectors, no dispatch, no state — all owned by the
// widget (per Phase 16 brief Step 11).

function ClientActivityScreen() {
  const { clientId } = useParams();

  return (
    <section
      className="feature-client-activity"
      id="Csection"
      tabIndex="-1"
    >
      <div className="container">
        <header className="feature-client-activity__header">
          <Heading level={1} variant="page">
            Активність клієнта
          </Heading>
          <Text as="p" size="sm" tone="secondary">
            Перегляд історії взаємодій з можливістю оновлення нотаток.
            Список активностей може застаріти — оновіть його вручну.
          </Text>
        </header>

        <ClientActivityScreenContent clientId={clientId} />
      </div>
    </section>
  );
}

export default ClientActivityScreen;
